module.exports = __webpack_public_path__ + "img/icon_sec2_3@2x.a815e8e5.png";